module.exports = __webpack_public_path__ + "static/winfire-banner-d1de93c34bd96e405f8c3767627d6e9a.jpg";